import React from "react";
import BookedMembersTicker from "./BookedMembersTicker";
import RoomsDonutWidget from "./RoomsDonutWidget";
import RallyCountdownWidget from "./RallyCountdownWidget";
import AccommodationPieWidget from "./AccommodationPieWidget";

export default function RallyStatsRow() {
  return (
    <div className="jp-stats-row">
      <BookedMembersTicker />
  <RoomsDonutWidget />
  <RallyCountdownWidget />
    </div>
  );
}